import { createReducer } from '@reduxjs/toolkit';

import { noop } from '@constants/general';

import {
  CONVERSION_TOOL_MAPPINGS_FETCH_REQUEST,
  CONVERSION_TOOL_MAPPINGS_FETCH_SUCCESS,
  CONVERSION_TOOL_MAPPINGS_FETCH_FAILURE,
  CONVERSION_TOOL_MAPPINGS_DELETE_REQUEST,
  CONVERSION_TOOL_MAPPINGS_DELETE_SUCCESS,
  CONVERSION_TOOL_MAPPINGS_DELETE_FAILURE,
} from './conversionToolMappings.const';

export const initialState = {
  model: [],
  meta: { hasError: false, isLoading: true, errorMessage: '' },
};

const conversionToolMappingsReducer = createReducer(initialState, builder => {
  builder
    .addCase(CONVERSION_TOOL_MAPPINGS_FETCH_REQUEST, state => {
      state.meta.isLoading = true;
      state.meta.hasError = false;
    })
    .addCase(CONVERSION_TOOL_MAPPINGS_FETCH_SUCCESS, (state, { payload }) => {
      state.meta.isLoading = false;
      state.model = payload;
      state.meta.hasError = false;
    })
    .addCase(CONVERSION_TOOL_MAPPINGS_FETCH_FAILURE, (state, { payload }) => {
      state.meta.isLoading = false;
      state.meta.hasError = true;
      state.meta.errorMessage = payload.errorMessage;
    })
    .addCase(CONVERSION_TOOL_MAPPINGS_DELETE_REQUEST, state => {
      state.meta.isLoading = true;
    })
    .addCase(CONVERSION_TOOL_MAPPINGS_DELETE_SUCCESS, (state, { payload }) => {
      state.meta.isLoading = false;
      state.model = state.model.filter(item => !item?.values?.includes(payload));
    })
    .addCase(CONVERSION_TOOL_MAPPINGS_DELETE_FAILURE, state => {
      state.meta.isLoading = false;
    })
    .addDefaultCase(noop);
});

export default conversionToolMappingsReducer;
